/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InitiateDataSharingResponseDto
 */
export interface InitiateDataSharingResponseDto {
    /**
     * Data sharing request ID
     * @type {string}
     * @memberof InitiateDataSharingResponseDto
     */
    requestId: string;
    /**
     * Data sharing status
     * @type {string}
     * @memberof InitiateDataSharingResponseDto
     */
    status: InitiateDataSharingResponseDtoStatusEnum;
    /**
     * Success message
     * @type {string}
     * @memberof InitiateDataSharingResponseDto
     */
    message: string;
}


/**
 * @export
 */
export const InitiateDataSharingResponseDtoStatusEnum = {
    Requesting: 'requesting',
    ActiveSharing: 'active_sharing',
    Revoked: 'revoked'
} as const;
export type InitiateDataSharingResponseDtoStatusEnum = typeof InitiateDataSharingResponseDtoStatusEnum[keyof typeof InitiateDataSharingResponseDtoStatusEnum];


/**
 * Check if a given object implements the InitiateDataSharingResponseDto interface.
 */
export function instanceOfInitiateDataSharingResponseDto(value: object): value is InitiateDataSharingResponseDto {
    if (!('requestId' in value) || value['requestId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function InitiateDataSharingResponseDtoFromJSON(json: any): InitiateDataSharingResponseDto {
    return InitiateDataSharingResponseDtoFromJSONTyped(json, false);
}

export function InitiateDataSharingResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InitiateDataSharingResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'requestId': json['requestId'],
        'status': json['status'],
        'message': json['message'],
    };
}

export function InitiateDataSharingResponseDtoToJSON(json: any): InitiateDataSharingResponseDto {
    return InitiateDataSharingResponseDtoToJSONTyped(json, false);
}

export function InitiateDataSharingResponseDtoToJSONTyped(value?: InitiateDataSharingResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'requestId': value['requestId'],
        'status': value['status'],
        'message': value['message'],
    };
}

